<ion-header class="ion-no-border ion-header-modal-desktop">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button data-cy="close-modal-button" (click)="closeModal()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label
      class="copy-order-modal-title-text"
      data-cy="copy-modal-title-text"
    >
      {{ 'i18n.orderPage.copyOrderModal.copyOrder' | translate }} #{{
        pastOrderRow?.orderHeader?.tandemOrderNumber
      }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ng-container *ngIf="productMap$ | async as productMap">
  <!-- display spinner until product data is available -->
  <ng-container
    *ngIf="
      allProductsLoaded(productMap, pastOrderRow?.orderItems);
      else spinner
    "
  >
    <ion-content class="ion-content-modal-desktop">
      <ion-grid>
        <!-- HOME PAGE -->
        <section>
          <ion-row>
            <ion-col>
              <div class="order-name" data-cy="copy-order-modal-title-text">
                <span class="bold">{{
                  pastOrderRow?.customer?.customerName | acronymTitleCase
                }}</span>
                ({{ pastOrderRow?.orderHeader?.customerNumber }})
                <span *ngIf="!!pastOrderRow?.orderHeader?.departmentNumber"
                  >, {{ 'i18n.orderPage.department' | translate }} ({{
                    pastOrderRow?.orderHeader?.departmentNumber
                  }})</span
                >
              </div>
              <p
                class="order-info-text"
                data-cy="copy-order-modal-order-info-text"
              >
                {{ 'i18n.orderPage.orderPlaced' | translate }}
                {{
                  pastOrderRow?.orderHeader?.orderDate
                    | date: 'M/d/yyyy' : 'GMT'
                }}
                <span class="mini-border">|</span>
                <ng-container
                  *ngIf="pastOrderRow?.orderHeader?.purchaseOrderNumber"
                >
                  <span>{{ 'i18n.orderStatusPage.poText' | translate }}: </span>
                  <span>
                    {{ pastOrderRow?.orderHeader?.purchaseOrderNumber }}</span
                  >
                  <span class="mini-border">|</span>
                </ng-container>
                {{ 'i18n.orderPage.ordered' | translate }}
                <ng-container
                  *ngIf="
                    pastOrderRow?.orderHeader?.totalUnits > 0 ||
                      pastOrderRow?.orderHeader?.totalEaches > 0;
                    else zeroUnitsAndEaches
                  "
                >
                  <span *ngIf="!!pastOrderRow?.orderHeader?.totalUnits">
                    {{ pastOrderRow?.orderHeader?.totalUnits }}
                    {{ 'i18n.common.cs' | translate }}
                  </span>
                  <span
                    *ngIf="
                      !!pastOrderRow?.orderHeader?.totalUnits &&
                      !!pastOrderRow?.orderHeader?.totalEaches
                    "
                  >
                    /
                  </span>
                  <span *ngIf="!!pastOrderRow?.orderHeader?.totalEaches">
                    {{ pastOrderRow?.orderHeader?.totalEaches }}
                    {{ 'i18n.common.ea' | translate }}</span
                  >
                </ng-container>
                <ng-template #zeroUnitsAndEaches>
                  <span> -</span>
                </ng-template>
                <span
                  *ngIf="
                    getUnavailableItemsText(
                      pastOrderRow?.orderItems,
                      productMap
                    ).length > 0
                  "
                  class="red-text"
                >
                  <span class="mini-border">|</span>
                  {{
                    getUnavailableItemsText(
                      pastOrderRow?.orderItems,
                      productMap
                    )
                  }}</span
                >
              </p>
            </ion-col>
          </ion-row>
          <ng-container
            *ngIf="
              isOrderContainingAvailableItems(
                pastOrderRow?.orderItems,
                productMap
              );
              else noAvailableItems
            "
          >
            <ng-container *ngFor="let orderItem of pastOrderRow?.orderItems">
              <ion-row
                *ngIf="
                  allProductsLoaded(productMap, pastOrderRow?.orderItems) &&
                  !isProductUnavailable(
                    productMap.get(orderItem?.productNumber)
                  )
                "
              >
                <ion-col size="12">
                  <!-- Product Container -->
                  <hr />
                  <div class="copy-order-product-row">
                    <div class="copy-order-row-wrapper">
                      <div class="copy-order-image-wrapper">
                        <img
                          *ngIf="
                            !!productMap.get(orderItem?.productNumber)
                              ?.imageThumbnail;
                            else noImageThumbnail
                          "
                          src="{{
                            productMap.get(orderItem?.productNumber)
                              ?.imageThumbnail
                          }}"
                        />
                        <ng-template #noImageThumbnail>
                          <ion-icon
                            data-cy="inventory-item-modal-product-no-image-icon"
                            class="product-img no-image"
                            name="restaurant"
                          ></ion-icon
                        ></ng-template>
                      </div>

                      <div
                        class="copy-order-product-info"
                        data-cy="copy-order-modal-product-info-text"
                      >
                        <div>
                          {{ orderItem?.productNumber }}
                          <span class="mini-border">|</span>
                          {{
                            productMap.get(orderItem?.productNumber)?.summary
                              ?.salesPackSize
                          }}
                        </div>
                        <div class="copy-order-modal-product-desc">
                          {{
                            productMap.get(orderItem?.productNumber)?.summary
                              ?.productDescTxtl | acronymTitleCase
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                      data-cy="copy-order-modal-cost-text"
                      class="copy-order-product-cost"
                      *ngIf="
                        productMap.get(orderItem?.productNumber)?.pricing
                          ?.unitPrice;
                        else priceSpinner
                      "
                    >
                      <div>
                        {{ 'i18n.orderPage.currentPrice' | translate }}
                        &nbsp;
                      </div>
                      <div>
                        <div>
                          {{
                            productMap.get(orderItem?.productNumber)?.pricing
                              ?.unitPrice | currency
                          }}
                          {{ 'i18n.common.cs' | translate }}
                        </div>
                        <div>
                          <span
                            *ngIf="
                              productMap.get(orderItem?.productNumber)?.pricing
                                ?.eachPrice !==
                                productMap.get(orderItem?.productNumber)
                                  ?.pricing?.unitPrice &&
                              orderItem?.eachesOrdered?.currentValue > 0
                            "
                          >
                            {{
                              productMap.get(orderItem?.productNumber)?.pricing
                                ?.eachPrice | currency
                            }}
                            {{ 'i18n.common.ea' | translate }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      data-cy="copy-order-modal-ordered-text"
                      class="copy-order-product-ordered"
                    >
                      <div>
                        {{ 'i18n.orderPage.ordered' | translate }}
                        &nbsp;
                      </div>
                      <div>
                        <div>
                          <span *ngIf="orderItem?.unitsOrdered?.currentValue">
                            {{ orderItem?.unitsOrdered?.currentValue }}
                            {{ 'i18n.common.cs' | translate }}</span
                          >
                        </div>
                        <div>
                          <span *ngIf="orderItem?.eachesOrdered?.currentValue">
                            {{ orderItem?.eachesOrdered?.currentValue }}
                            {{ 'i18n.common.ea' | translate }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Product Container-->

                  <hr />
                </ion-col>
              </ion-row>
            </ng-container>
          </ng-container>
        </section>
      </ion-grid>
    </ion-content>
  </ng-container>

  <ion-footer class="ion-footer-modal ion-footer-modal-desktop">
    <ion-toolbar>
      <ion-buttons>
        <ion-button
          data-cy="close-copy-order-modal-button"
          class="usf-outline-green-dsktp-tblt-modal-button"
          (click)="closeModal()"
        >
          {{ 'i18n.common.close' | translate }}
        </ion-button>
        <ion-button
          data-cy="copy-order-modal-button"
          [ngClass]="
            !allProductsLoaded(productMap, pastOrderRow?.orderItems) ||
            !orderContainsAvailableItems
              ? 'usf-fill-disabled-dsktp-tblt-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
          "
          (click)="copyOrder(productMap)"
          [disabled]="
            !allProductsLoaded(productMap, pastOrderRow?.orderItems) ||
            !orderContainsAvailableItems ||
            ordersLoading
          "
        >
          {{ 'i18n.common.copy' | translate }}
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</ng-container>

<ng-template #spinner>
  <ion-spinner name="circles" class="copy-order-modal-spinner"></ion-spinner>
</ng-template>
<ng-template #priceSpinner>
  <ion-spinner
    name="circles"
    class="copy-order-modal-price-spinner"
  ></ion-spinner>
</ng-template>
<ng-template #noAvailableItems>
  <div class="all-items-unavailable">
    <span><ion-icon name="alert-circle-outline"></ion-icon></span>
    <span>{{
      'i18n.orderPage.copyOrderModal.allItemsUnavailable' | translate
    }}</span>
  </div>
</ng-template>
